<template>
  <div class="singleWrapper" id="singleWrapper" @scroll="handleScroll">
    <div class="topWra" ref="topWra">
      <div class="searchWra">
        <input
          type="text"
          class="input"
          v-model="input"
          placeholder="请输入项目名称/适合专业/导师院校/一二级学科标签等关键词"
          @change="search"
        />
        <img class="searchIcon" src="./icon/search.png" alt="" />
      </div>
      <div class="select">
        <el-row>
          <el-col
            :span="6"
            style="display: flex;justify-content: left;align-items: center"
          >
            <div
              @click="showLibrarySelect = !showLibrarySelect"
              class="selecting library-select"
              :class="{
                selected: showLibrarySelect
              }"
            >
              {{ currentLibrary === 'xhd' ? '新航道' : '科研D计划' }}
            </div>
          </el-col>
          <el-col
            :span="8"
            style="display: flex;justify-content: left;align-items: center"
          >
            <div
              @click="
                select.showS = !select.showS
                select.showD = false
                showLibrarySelect = false
              "
              class="selecting"
              :class="{
                selected: select.showS,
                hasSelected: select.directions.length > 0
              }"
            >
              学科方向
            </div>
          </el-col>
          <el-col
            :span="5"
            style="display: flex;justify-content: left;align-items: center"
          >
            <div
              @click="
                select.showD = !select.showD
                select.showS = false
                showLibrarySelect = false
              "
              class="selecting"
              :class="{
                selected: select.showD,
                hasSelected: select.degree.length
              }"
            >
              难度
            </div>
          </el-col>
        </el-row>
        <div v-if="showLibrarySelect" class="library-options">
          <div
            class="library-option"
            :class="{ active: currentLibrary === 'xhd' }"
            @click="switchLibrary('xhd')"
          >
            新航道
          </div>
          <div
            class="library-option"
            :class="{ active: currentLibrary === 'research' }"
            @click="switchLibrary('research')"
          >
            科研D计划
          </div>
        </div>
      </div>
    </div>
    <!--    <div style="margin-top: 100rem*0.04"><p v-for="item in select.directions">{{item}}</p></div>-->
    <degreeSelect
      @degreeSelect="directionSelect"
      :type="currentLibrary === 'xhd' ? 'thesis' : 'research'"
      :select="select"
      v-if="select.showD"
    ></degreeSelect>
    <directionSelect
      @directionSelect="directionSelect"
      :type="currentLibrary === 'xhd' ? 'thesis' : 'research'"
      :select="select"
      v-if="select.showS"
    ></directionSelect>

    <div class="mainWra" ref="mainWra">
      <!--      加载中-->
      <div v-if="(!topics.length && has_next) || firstLoad" class="loading">
        <i class="el-icon-loading"></i>
        <div>加载中，请稍后...</div>
      </div>
      <!--      主体-->
      <div v-for="item in topics" :key="item.id">
        <listItem
          v-if="currentLibrary === 'xhd'"
          :type="'xhd'"
          :hot="hot"
          :data="item"
        ></listItem>
        <listItemOld
          v-else
          :type="'research'"
          :data="item"
        ></listItemOld>
      </div>
      <!--      下拉到底-->
      <div class="loading" v-if="has_next && !!topics.length">
        <i class="el-icon-loading"></i>
        <div>加载中，请稍后...</div>
      </div>
      <div v-if="!has_next && !!topics.length" class="loading">
        到底了
      </div>
      <div v-if="!has_next && !topics.length && !firstLoad" class="loading">
        没有找到相关选题
      </div>
    </div>
  </div>
</template>

<script>
import listItem from './listItem'
import listItemOld from './listItem-old'
import axios from '../../axios'
import directionSelect from './directionSelect'
import degreeSelect from './degreeSelect'
import { debounce } from 'lodash'

export default {
  name: 'researchMobile',
  components: {
    listItem,
    listItemOld,
    directionSelect,
    degreeSelect
  },
  data () {
    return {
      input: '',
      topics: [],
      page: 1,
      select: {
        directions: [],
        degree: [],
        showS: false,
        showD: false
      },
      firstLoad: true,
      hot: true,
      has_next: false,
      has_previous: false,
      pack: true,
      type: 'research',
      skeleton: new Array(6),
      qrcode: '',
      loading: true,
      showLibrarySelect: false,
      currentLibrary: 'xhd'
    }
  },
  created () {
    document.title = '定制学术指导'
    let path = this.$route.path
    this.qrcode = path.split('/').pop()
    this.postList()
    this.getTitle()
  },
  methods: {
    getTitle () {
      axios
        .get('/enterpise/DBS_list', {
          params: {
            type: this.currentLibrary,
            qrcode: this.qrcode
          }
        })
        .then(res => {
          if (this.currentLibrary === 'xhd') {
            document.title = res.data.title || '定制学术指导'
          } else {
            document.title = res.data.title || '科研项目'
          }
        })
    },
    postList () {
      this.loading = true
      const degree = this.select.degree.length > 0 ? Math.max(...this.select.degree) : null
      const params = {
        keyword: this.input,
        page: this.page,
        qrcode: this.qrcode,
        tags: this.select.directions,
        degree: degree,
        type: this.type,
        pack: this.pack
      }

      console.log('API请求参数:', params)
      console.log('当前库:', this.currentLibrary)

      axios
        .post('/enterpise/topic_list', params)
        .then(response => {
          console.log('API响应数据:', response.data)
          this.topics.push(...response.data.topics)
          this.has_next = response.data.has_next
          this.has_previous = response.data.has_previous
          this.page++
          this.firstLoad = false
          this.loading = false
        })
        .catch(error => {
          console.error('API请求失败:', error)
          this.loading = false
          this.firstLoad = false
        })
    },
    switchLibrary (library) {
      if (this.currentLibrary === library) {
        this.showLibrarySelect = false
        return
      }

      console.log('切换选题库:', this.currentLibrary, '->', library)

      this.currentLibrary = library
      this.showLibrarySelect = false

      // 重置所有状态
      this.input = ''
      this.topics = []
      this.page = 1
      this.select = {
        directions: [],
        degree: [],
        showS: false,
        showD: false
      }
      this.firstLoad = true
      this.has_next = false
      this.has_previous = false

      // 根据选择的库调整参数
      if (library === 'xhd') {
        this.pack = true
        this.type = 'research'
        console.log('设置为新航道参数: pack=true, type=research')
      } else if (library === 'research') {
        this.pack = false
        this.type = 'research'
        console.log('设置为科研D计划参数: pack=false, type=research')
      }

      // 重新获取标题和数据
      this.getTitle()
      this.postList()

      // 滚动到顶部
      document.getElementById('singleWrapper').scrollTop = 0
    },
    // 学科方向组件回调
    directionSelect () {
      this.select.showS = false
      this.select.showD = false
      this.showLibrarySelect = false
      this.page = 1
      this.search()
      document.getElementById('singleWrapper').scrollTop = 0
    },
    handleScroll: debounce(function (e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target
      console.log(scrollTop + clientHeight, scrollHeight)
      if (scrollTop + clientHeight >= scrollHeight - 200) {
        if (this.has_next && !this.loading) {
          this.postList()
        }
      }
    }, 200),
    search () {
      this.page = 1
      this.topics = []
      this.postList()
    }
  }
}
</script>

<style scoped lang="scss">
.el-icon-sort {
  margin-right: 7rem * 0.04;
  display: inline-block;
}
@media screen and (max-width: 600px) {
  .singleWrapper {
    width: 100vw;
  }
}
@media screen and (min-width: 601px) {
  .singleWrapper {
    width: 400px;
    margin: 0 auto;
  }
}
.singleWrapper {
  background-color: #f6f8fb;
  height: 100vh;
  overflow: scroll;
  .topWra {
    background-color: #f6f8fb;
    box-sizing: border-box;
    width: 100%;
    position: sticky;
    top: 0;
    padding: 20rem * 0.04 12rem * 0.04 12rem * 0.04;
    border-bottom: #e8e8e8 2rem * 0.04 solid;
    z-index: 3;
    .searchWra {
      position: relative;
      height: 24rem * 0.04;
      .input {
        width: 100%;
        height: 100%;
        font-size: 10rem * 0.04;
        box-sizing: border-box;
        border: #656d78 1rem * 0.04 solid;
        padding-left: 12rem * 0.04;
        display: block;
        &::-webkit-input-placeholder {
          font-size: 10rem * 0.04;
          color: #9b9b9b;
        }
      }
      .searchIcon {
        position: absolute;
        width: 10rem * 0.04;
        height: 11rem * 0.04;
        top: 8rem * 0.04;
        right: 12rem * 0.04;
      }
    }
    .select {
      font-size: 12rem * 0.04;
      text-align: left;
      margin-top: 8rem * 0.04;
      padding: 0 8rem * 0.04;
      div.selected {
        color: #d0af8b;
        &::after {
          transition: 0.3s;
          transform: rotate(180deg);
          transform-origin: 50% 25%;
          //top: -1rem*0.04;
          border-top-color: #d0af8b;
        }
      }
      .hasSelected {
        color: #d0af8b;
        &::after {
          border-top-color: #d0af8b !important;
        }
      }
      .selecting {
        &::after {
          border: #f6f8fb 5rem * 0.04 solid;
          border-top-color: #434a54;
          content: '';
          display: inline-block;
          width: 0;
          height: 0;
          transition: 0.3s;
          transform: rotate(0deg);
          transform-origin: 50% 25%;
          position: relative;
          top: 4rem * 0.04;
          left: 8rem * 0.04;
        }
      }
    }
  }
  .mainWra {
    padding: 0 20rem * 0.04;
  }
}
.loading {
  font-size: 10rem * 0.04;
  text-align: center;
}

.library-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 10;
  margin-top: 4px;
}

.library-option {
  padding: 12px 16px;
  cursor: pointer;
  font-size: 12px;
  color: #434a54;
  border-bottom: 1px solid #f0f0f0;

  &:hover {
    background-color: #f6f8fb;
  }

  &.active {
    color: #d0af8b;
    font-weight: bold;
  }

  &:last-child {
    border-bottom: none;
  }
}

.library-select {
  color: #d0af8b !important;
}
</style>
